export const SET_TYPE_EXHIBITION = 'SET_TYPE_EXHIBITION';

export const setTypeExhibition = (exhibition) => ({
        type: SET_TYPE_EXHIBITION,
        exhibition
})

